import { Card } from "@cofano/cck";
import type { ComponentType } from "react";
import type { ConfigFormProps } from "view/dashboard/widgets/sources/types";

type WidgetConfigSectionProps = {
	title: string;
	prefix: string;
	form: ComponentType<ConfigFormProps>;
};

const WidgetConfigSection = ({ title, prefix, form: Form }: WidgetConfigSectionProps) => {
	return <Card title={title} startNested>
		<Form prefix={prefix} />
	</Card>;
};

export default WidgetConfigSection;
